import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { Cluster } from './cluster.interface';

export class ClusterService {
   async getClusters(search: string) {
      const response = await http.get<ApiResource<Array<Cluster>>>('/clusters', { params: { include: 'teams', search } });
      return response.data;
   }

   async getCluster() {
      throw Error('Method not implemented');
   }

   async postCluster() {
      throw Error('Method not implemented');
   }

   async putCluster() {
      throw Error('Method not implemented');
   }

   async deleteCluster() {
      throw Error('Method not implemented');
   }
}
